import React, { MouseEvent, useCallback, useState } from 'react';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { Link } from 'react-router';

import { PlateList } from '@paragon/contract-library';
import { hasMaterialsEditPermission } from '@paragon/login-tools';
import { getDefaultPlateListGuid } from '@paragon/material-lists';

import { setDefaultPlateListGuid } from '../../../actions/defaultMaterialSelectionActions';
import {
  archivePlateList,
  duplicatePlateList,
  renamePlateList,
  restorePlateList,
} from '../../../actions/plateListActions';
import { useAppSelector } from '../../hooks';
import { ListMenu } from '../ListMenu';
import { PossiblyArchivedListName } from '../PossiblyArchivedListName';
import { cardSx, defaultListIconSx, flexRowCenteredItemsSx } from './common/card-styles';
import { DefaultListIcon } from './common/DefaultListIcon';

export function PlateListCard(props: { value: PlateList }) {
  const defaultPlateListGuid = useAppSelector(getDefaultPlateListGuid);
  const hasEditPermission = useAppSelector(hasMaterialsEditPermission);

  const [menuPosition, setMenuPosition] = useState<null | { x: number; y: number }>(null);

  const onContextMenuRequested = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      setMenuPosition({ x: event.clientX, y: event.clientY });
    },
    [setMenuPosition],
  );

  return (
    <Card elevation={0} sx={cardSx}>
      <CardActionArea component={Link} to={`/plateLists/${props.value.guid}`} onContextMenu={onContextMenuRequested}>
        <CardContent>
          <Typography variant="h6" sx={flexRowCenteredItemsSx} gutterBottom>
            <PossiblyArchivedListName name={props.value.name} isArchived={props.value.isArchived} />

            <DefaultListIcon type="plate" visible={props.value.guid === defaultPlateListGuid} sx={defaultListIconSx} />
          </Typography>
          <Typography variant="body2">
            {props.value.plates.length} plate pair{props.value.plates.length === 1 ? '' : 's'}
          </Typography>
        </CardContent>
      </CardActionArea>
      {hasEditPermission && (
        <ListMenu
          noun="plate"
          list={props.value}
          anchor={menuPosition}
          onClose={() => setMenuPosition(null)}
          setDefaultListGuid={setDefaultPlateListGuid}
          archiveList={archivePlateList}
          restoreList={restorePlateList}
          duplicateList={duplicatePlateList}
          renameList={renamePlateList}
        />
      )}
    </Card>
  );
}
